<template>
  <!-- Services section start -->
  <section
    id="services-section"
    class="px-12 lg:px-32 py-16 relative overflow-hidden"
  >
    <!-- Text wrapper start -->
    <div class="flex gap-8 flex-col md:flex-row">
      <!-- Main text start -->
      <h1 class="uppercase text-5xl mb-4 font-semibold services-title">
        <strong>{{ $t("services.ourServices") }}</strong>
      </h1>
      <p class="xl:w-1/2 text-stone-500 mb-8 services-text text-justify">
        {{ $t("services.offer") }} {{ $t("services.check") }}
      </p>
      <!-- Main text end -->
    </div>
    <!-- Text wrapper end -->

    <!-- Circle start -->
    <div
      class="bg-[#132e63] h-64 w-64 rounded-full absolute top-0 -right-20 mt-16 -z-20 opacity-20"
    ></div>
    <!-- Circle end -->

    <v-combobox
      :label="$t('services.servicesSelector.selectLocation')"
      class="mb-4 w-4/5 mx-auto"
      :items="availableStates.map((location) => location.name)"
      v-model="selectedState"
    >
    </v-combobox
    ><br />
    <v-row>
      <v-col
        v-for="item in selectedServices"
        :key="item.id"
        :title="item.name"
        :id="item.id"
        cols="12"
        md="4"
        sm="6"
        style="height: 100% !important"
      >
        <router-link :to="{ path: '/services', hash: '#servicesView' }" class="no-underline">
          <v-card style="height: 100% !important;"><div  class="name">{{ item.name }}</div>
            <div class="service-image-container">
              <img
                :src="item.image"
                alt="taxes"
                class="-z-50 md:mb-4 service-image"
              />
            </div>
            <v-card-text
              class="bg-surface-light pt-4 description"
            >
              {{ item.description }}
            </v-card-text>
            <!-- Avaliability of service -->
            <v-card-text class="bg-surface-light pt-4 availability">
              {{ item.availability }}
            </v-card-text>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
  </section>
  <!-- Services section end -->
</template>

<script>
import {
  services as originalServices,
  availableStates as originalAvailableStates,
} from "../utils/constants.js";

export default {
  data() {
    return {
      selectedStateName: null,
      selectedState: null,
    };
  },

  computed: {
    // Computed property to translate availableStates
    availableStates() {
      return originalAvailableStates.map((state) => ({
        ...state,
        name: this.$t(state.name),
      }));
    },

    // Computed property to translate services
    services() {
      return originalServices.map((service) => ({
        ...service,
        name: this.$t(service.name),
        description: this.$t(service.description),
        content: this.$t(service.content),
        availability: this.$t(service.availability),
      }));
    },
    // Computed property to filter services based on the selected state
    selectedServices() {
      const selectedState = this.availableStates.find(
        (state) => state.name === this.selectedState
      );
      if (selectedState) {
        return this.services.filter((service) =>
          selectedState.availableServices.includes(service.id)
        );
      }
      return [];
    },
  },

  mounted() {
    // Translate availableStates and services
    this.availableStates = originalAvailableStates.map((state) => ({
      ...state,
      name: this.$t(state.name),
    }));

    this.services = originalServices.map((service) => ({
      ...service,
      name: this.$t(service.name),
      description: this.$t(service.description),
      content: this.$t(service.content),
      availability: this.$t(service.availability),
    }));

    // Initialize selectedState with the first available state
    if (this.availableStates.length > 0) {
      this.selectedState = this.availableStates[0].name;
    }
  },
  watch: {
    "$i18n.locale": function (newVal) {
      console.log("locale change", newVal);
      this.selectedState = this.availableStates[0].name;
    },
  },

  name: "ServicesSection",
};
</script>

<style scoped>
#services-section {
  color: #051328 !important;
}
.services-title {
  color: #132e63;
}
.services-text {
  color: #051328 !important;
}
.v-combobox {
  border-radius: 0.5rem;
  background-color: rgba(19, 46, 99, 0.1);
}

.v-combobox .v-input__control {
  color: #051328 !important;
  font-weight: normal !important;
}

.v-card {
  background-color: #ffffff;
  border: 0.5px solid #132e63;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow:visible;
}
.description {
  color: #051328;
  font-size: 1rem;
  font-weight: normal;
  text-align: justify !important;
  height: 100px;
}

.service-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px; /* Altura fija para el contenedor de la imagen */
  overflow: hidden; /* Oculta cualquier contenido que desborde */
}

.service-image {
  justify-content: center !important;
  align-items: center; /* Centra verticalmente */
  width: 30%;
  height: fit-content;
  border-radius: 0.5rem;
}
.name {
  color: #132e63;
  font-size: 2rem;
  font-stretch: 50%;
  text-overflow:ellipsis;
  font-weight: bold;
  text-align: center !important;
  overflow: clip !important;
  white-space: normal; /* Permite saltos de línea */
  overflow: hidden; /* Or other overflow values like 'scroll' */
  white-space: nowrap; /* Prevent text from wrapping */
}
.availability {
  color: #132e63 !important;
  font-size: 0.8rem;
  text-align: center !important;
  font-weight: bold;
}

@media (max-width: 1658px) {
  .name {
  font-size: 1.5rem !important;
  }
  
 }

 @media (max-width: 1336px) {
  .description {
    height: 120px;
  }
  
 }

 @media (max-width: 1283px) {
  .name {
  font-size: 1.2rem !important;
  }
  
 }
 @media (max-width: 1216px) {
  .description {
    height: 120px;
  }
  
 }

 @media (max-width: 1055px) {
  .name {
  font-size: 1rem !important;
  }
  
 }

 @media (max-width: 653px) {
  .description {
    height: 150px;
  }
  
 }

  @media (max-width: 400px) {
  .description {
    height: 200px;
  }
  
 }
</style>
